<template>
    <li class="col-md-4 col-xl-3 posr"
        :style="{ backgroundImage: `url(${src})`}">
        <div class="item pageShadowBox">
            <router-link :to="to">
                <div class="link posa">
                    {{ title }}
                </div>
            </router-link>
            <a class="blot posa" @click="addCollection(product)" :class="{ 'active': product.Favorites }"></a>
        </div>
        <div class="day">
            <img :src="require('@/assets/images/icon/time.svg')">
            {{ date }}
        </div>
    </li>
</template>

<script>
    import _ from 'lodash'
    import addCollectionMixin from '@/mixins/addCollection'

    export default {
        mixins: [addCollectionMixin],
        props: {
            product: {
                type: Object,
                required: true
            },
        },
        computed: {
            src() {
                return _.get(this.product, 'CoverImage');
            },
            to() {
                let parentid = _.get(this.product, 'TypeID');
                let id = _.get(this.product, 'InitID');
                return {
                    name: 'products.show',
                    params: {
                        parentid,
                        id,
                    },
                };
            },
            date() {
                return _.get(this.product, 'ClassDate');
            },
            title() {
                return _.get(this.product, 'ClassTitle');
            },
        }
    }
</script>